import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/layout/Layout';
import PermissionGuard from './components/PermissionGuard';
import ProtectedRoute from './components/ProtectedRoute';
import { ToastProvider } from './components/ui/Toast';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { DataCacheProvider } from './contexts/DataCacheContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Atendimento from './pages/Atendimento';
import CampaignItemPage from './pages/CampaignItemPage';
import Campaigns from './pages/Campaigns';
import Customers from './pages/Customers';
import EmployeesPage from './pages/EmployeesPage';
import ColetasPage from './pages/ColetasPage';
import ColetasEnvioDiaPage from './pages/ColetasEnvioDiaPage';
import Garantia from './pages/Garantia';
import Health from './pages/Health';
import OperadorParaQuiosque from './components/layout/OperadorParaQuiosque';
import KioskShell from './components/warehouse/collector/KioskShell';
import Login from './pages/Login';
import MarketIntelligence from './pages/MarketIntelligence';
import MlExplorer from './pages/MlExplorer';
import Navios from './pages/Navios';
import NotFound from './pages/NotFound';
import Orders from './pages/Orders';
import OrganizationsPage from './pages/Organizations';
import Operacoes from './pages/operacoes';
import PaymentOrderDetail from './pages/PaymentOrderDetail';
import PaymentOrderExperience from './pages/PaymentOrderExperience';
import Payments from './pages/Payments';
import Pricing from './pages/Pricing';
import PricingSkuPage from './pages/PricingSkuPage';
import Profile from './pages/Profile';
import Promotions from './pages/Promotions';
import Purchasing from './pages/Purchasing';
import PedidoDetail from './pages/pedidos/PedidoDetail';
import Pedidos from './pages/pedidos/Pedidos';
import PedidosRegras from './pages/pedidos/Regras';
import ProductEditorPage, { ProductEditorRoute } from './pages/produtos/ProductEditorPage';
import ProductsPage from './pages/produtos/ProductsPage';
import RmaDetail from './pages/RmaDetail';
import Rmas from './pages/Rmas';
import Sellout from './pages/Sellout';
import UserProfilePage from './pages/UserProfilePage';
import Users from './pages/Users';
import WmsDashboard from './pages/wms/DashboardPage';
import WmsOutboundCreate from './pages/wms/InboundCreatePage';
import WmsOutboundDetails from './pages/wms/OutboundDetailsPage';
import WarehouseBenchStation from './pages/warehouse/WarehouseBenchStation';
import WarehouseCollectorPage from './pages/warehouse/WarehouseCollectorPage';
import WarehouseConfigurationsPage from './pages/warehouse/WarehouseConfigurationsPage';
import WarehouseInboundPage from './pages/warehouse/WarehouseInboundPage';
import WarehouseIncidentsPage from './pages/warehouse/WarehouseIncidentsPage';
import WarehouseInventoryPage from './pages/warehouse/WarehouseInventoryPage';
import WarehouseLocationsPage from './pages/warehouse/WarehouseLocationsPage';
import WarehouseLpnsPage from './pages/warehouse/WarehouseLpnsPage';
import WarehouseProductionPage from './pages/warehouse/WarehouseProductionPage';
import WarehouseRepackPage from './pages/warehouse/WarehouseRepackPage';
import WarehouseReturnsPage from './pages/warehouse/WarehouseReturnsPage';
import WarehouseServiceOrdersPage from './pages/warehouse/WarehouseServiceOrdersPage';
import WarehouseShippingPage from './pages/warehouse/WarehouseShippingPage';
// ⚠️ TEMPORÁRIO — NÃO COMITAR (protótipo de processo, ver rota /prototipo/outbound)
import OutboundFlowPrototype from './prototypes/OutboundFlowPrototype';

function App() {
    return (
        <BrowserRouter
            future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
            }}
        >
            <ThemeProvider>
                <AuthProvider>
                    <DataCacheProvider>
                        <CartProvider>
                            <ToastProvider>
                                <Routes>
                                    <Route path="/login" element={<Login />} />
                                    <Route element={<ProtectedRoute />}>
                                        {/* TERMINAIS de chão (quiosque): as MESMAS páginas do WMS,
                                            sem sidebar/navbar — o operador só vê o posto. Crachá é
                                            só-leitor aqui (KioskContext). A conta de terminal fica
                                            TRANCADA no posto dela pelo ProtectedRoute
                                            (utils/kioskAccount). */}
                                        <Route
                                            path="/coletor"
                                            element={
                                                <PermissionGuard permission="wms:operate">
                                                    <KioskShell>
                                                        <WarehouseCollectorPage />
                                                    </KioskShell>
                                                </PermissionGuard>
                                            }
                                        />
                                        <Route
                                            path="/bancada"
                                            element={
                                                <PermissionGuard permission="wms:operate">
                                                    <KioskShell>
                                                        <WarehouseBenchStation />
                                                    </KioskShell>
                                                </PermissionGuard>
                                            }
                                        />
                                        <Route element={<Layout />}>
                                            <Route
                                                path="/operacoes"
                                                element={
                                                    <PermissionGuard permission="operacoes:read">
                                                        <Operacoes />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route path="/" element={<OperadorParaQuiosque />} />
                                            <Route path="/dashboard" element={<Navigate to="/" replace />} />
                                            <Route path="/profile" element={<Profile />} />
                                            <Route
                                                path="/orders"
                                                element={
                                                    <PermissionGuard permission="orders:read">
                                                        <Orders />
                                                    </PermissionGuard>
                                                }
                                            />
                                            {/* Gestão de Pedidos (2026-09-22): tela NOVA em teste —
                                            /orders continua intacta. */}
                                            <Route
                                                path="/pedidos"
                                                element={
                                                    <PermissionGuard permission="orders:read">
                                                        <Pedidos />
                                                    </PermissionGuard>
                                                }
                                            />
                                            {/* Regras da Gestão de Pedidos (rodada 3b): leitura com
                                            orders:read; editar exige orders:write (na página). */}
                                            <Route
                                                path="/pedidos/regras"
                                                element={
                                                    <PermissionGuard permission="orders:read">
                                                        <PedidosRegras />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/pedidos/:orderId"
                                                element={
                                                    <PermissionGuard permission="orders:read">
                                                        <PedidoDetail />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/customers"
                                                element={
                                                    <PermissionGuard permission="customers:read">
                                                        <Customers />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/customers/:buyerId"
                                                element={
                                                    <PermissionGuard permission="customers:read">
                                                        <Customers />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/funcionarios"
                                                element={
                                                    <PermissionGuard permission="employees:read">
                                                        <EmployeesPage />
                                                    </PermissionGuard>
                                                }
                                            />
                                            {/* Cadastro de produto PRÓPRIO: lista, novo e editor.
                                                `:productId` é o UUID products.id — nunca o SKU (há SKU
                                                com `/` e `%`, que a rota decodificaria). */}
                                            <Route
                                                path="/produtos"
                                                element={
                                                    <PermissionGuard permission="stock:read">
                                                        <ProductsPage />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/produtos/novo"
                                                element={
                                                    <PermissionGuard permission="stock:write">
                                                        <ProductEditorPage mode="new" />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/produtos/:productId"
                                                element={
                                                    <PermissionGuard permission="stock:read">
                                                        <ProductEditorRoute />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/navios"
                                                element={
                                                    <PermissionGuard permission="navios:read">
                                                        <Navios />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/coletas"
                                                element={
                                                    <PermissionGuard permission="wms:read">
                                                        <ColetasPage />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/coletas/envios/:dia"
                                                element={
                                                    <PermissionGuard permission="wms:read">
                                                        <ColetasEnvioDiaPage />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/sellout"
                                                element={
                                                    <PermissionGuard permission="sellout:read">
                                                        <Sellout />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/purchasing"
                                                element={
                                                    <PermissionGuard permission="purchasing:read">
                                                        <Purchasing />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/campaigns"
                                                element={
                                                    <PermissionGuard permission="campaigns:read">
                                                        <Campaigns />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/campaigns/items/:itemId"
                                                element={
                                                    // Página do anúncio: mesma permissão e mesmos dados do monitor.
                                                    <PermissionGuard permission="campaigns:read">
                                                        <CampaignItemPage />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/market-intelligence"
                                                element={
                                                    // Mesma permissão de /campaigns: a Inteligência lê os
                                                    // MESMOS dados de campanha, só em página própria.
                                                    <PermissionGuard permission="campaigns:read">
                                                        <MarketIntelligence />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/precificacao"
                                                element={
                                                    <PermissionGuard permission="pricing:read">
                                                        <Pricing />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/precificacao/sku/:sku"
                                                element={
                                                    <PermissionGuard permission="pricing:read">
                                                        <PricingSkuPage />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/ml-explorer"
                                                element={
                                                    // Mesma permissão de /campaigns: a tela lê os MESMOS dados
                                                    // do Mercado Livre que o módulo de campanhas já mostra,
                                                    // só que crus, direto da API.
                                                    <PermissionGuard permission="campaigns:read">
                                                        <MlExplorer />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/promotions"
                                                element={
                                                    <PermissionGuard permission="campaigns:read">
                                                        <Promotions />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/payments"
                                                element={
                                                    <PermissionGuard permission="payments:read">
                                                        <Payments />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/payments/order/:orderId"
                                                element={
                                                    <PermissionGuard permission="payments:read">
                                                        <PaymentOrderDetail />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/payments/order/:orderId/nova"
                                                element={
                                                    <PermissionGuard permission="payments:read">
                                                        <PaymentOrderExperience />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/health"
                                                element={
                                                    <PermissionGuard permission="health:read">
                                                        <Health />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/atendimento"
                                                element={
                                                    <PermissionGuard permission="atendimento:read">
                                                        <Atendimento />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/rmas"
                                                element={
                                                    <PermissionGuard permission="rmas:read">
                                                        <Rmas />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/rmas/:id"
                                                element={
                                                    <PermissionGuard permission="rmas:read">
                                                        <RmaDetail />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/garantia"
                                                element={
                                                    <PermissionGuard permission="rmas:read">
                                                        <Garantia />
                                                    </PermissionGuard>
                                                }
                                            />

                                            {/* ⚠️ TEMPORÁRIO — NÃO COMITAR.
                                            Protótipo de processo do fluxo de saída do WMS, para o dono
                                            avaliar se a ordem das etapas faz sentido. Dados fictícios,
                                            nenhuma chamada de API. Some junto com src/prototypes/. */}
                                            <Route
                                                path="/prototipo/outbound"
                                                element={
                                                    <PermissionGuard permission="wms:read">
                                                        <OutboundFlowPrototype />
                                                    </PermissionGuard>
                                                }
                                            />

                                            {/* WMS Routes */}
                                            <Route
                                                path="/wms"
                                                element={
                                                    <PermissionGuard permission="wms:read">
                                                        <WmsDashboard />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/wms/create"
                                                element={
                                                    <PermissionGuard permission="wms:outbound:create">
                                                        <WmsOutboundCreate />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/wms/outbound/:id"
                                                element={
                                                    <PermissionGuard permission="wms:read">
                                                        <WmsOutboundDetails />
                                                    </PermissionGuard>
                                                }
                                            />

                                        {/* Armazém (módulo WMS novo — M0/M1): console do Supervisor + coletor */}
                                        <Route
                                            path="/warehouse"
                                            element={
                                                <PermissionGuard
                                                    anyOf={[
                                                        'wms:manage:operators',
                                                        'wms:manage:equipment',
                                                        'wms:manage:lpn_prefixes',
                                                        'wms:manage:service_order_types',
                                                        'wms:manage:deposits',
                                                        'wms:manage:deposit_rules',
                                                        'wms:manage:products',
                                                        'wms:manage:printers',
                                                        'wms:manage:settings',
                                                    ]}
                                                >
                                                    <WarehouseConfigurationsPage />
                                                </PermissionGuard>
                                            }
                                        />
                                        <Route
                                            path="/warehouse/locations"
                                            element={
                                                <PermissionGuard permission="wms:manage:locations">
                                                    <WarehouseLocationsPage />
                                                </PermissionGuard>
                                            }
                                        />
                                        <Route
                                            path="/warehouse/lpns"
                                            element={
                                                <PermissionGuard permission="wms:manage:lpns">
                                                    <WarehouseLpnsPage />
                                                </PermissionGuard>
                                            }
                                        />
                                        {/* INBOUND contra OC (20/08): console do recebimento —
                                            escolher a OC, ver esperado × recebido, receber
                                            (LPN + incremento da OC na mesma transação) e
                                            confrontar com a NF do fornecedor. */}
                                        <Route
                                            path="/warehouse/inbound"
                                            element={
                                                <PermissionGuard permission="wms:manage:inbound">
                                                    <WarehouseInboundPage />
                                                </PermissionGuard>
                                            }
                                        />
                                        {/* ENTRADA DE DEVOLUÇÕES (20/08): chegada + separação
                                            (volta ao vendável × retorno ao fornecedor).
                                            Independente do módulo rmas — integração é fase
                                            futura. */}
                                        <Route
                                            path="/warehouse/returns"
                                            element={
                                                <PermissionGuard permission="wms:manage:returns">
                                                    <WarehouseReturnsPage />
                                                </PermissionGuard>
                                            }
                                        />
                                        <Route
                                            path="/warehouse/collector"
                                            element={
                                                <PermissionGuard permission="wms:operate">
                                                    <WarehouseCollectorPage />
                                                </PermissionGuard>
                                            }
                                        />
                                        {/* M6 — console da fábrica (Supervisor): OPs,
                                            lotes/genealogia e os cadastros de produção.
                                            Permissão granular própria, como as outras
                                            páginas do módulo. */}
                                        <Route
                                            path="/warehouse/production"
                                            element={
                                                <PermissionGuard permission="wms:manage:production">
                                                    <WarehouseProductionPage />
                                                </PermissionGuard>
                                            }
                                        />
                                        {/* M6 — BANCADA dentro do Layout: a MESMA estação de
                                            /bancada, para quem é de mesa (admin/supervisor).
                                            Aqui não há quiosque: nem tela cheia automática
                                            nem o botão Melidash. Conta de terminal nunca
                                            chega aqui (trava do ProtectedRoute). */}
                                        <Route
                                            path="/warehouse/bench"
                                            element={
                                                <PermissionGuard permission="wms:operate">
                                                    <WarehouseBenchStation />
                                                </PermissionGuard>
                                            }
                                        />
                                        {/* M4 — fila de incidentes do Supervisor. Página própria
                                            (e não aba das Configurações): é evento operacional com
                                            ciclo OPEN→RESOLVED, não cadastro. Justificativa completa
                                            no topo de WarehouseIncidentsPage.jsx. */}
                                        <Route
                                            path="/warehouse/incidents"
                                            element={
                                                <PermissionGuard permission="wms:manage:incidents">
                                                    <WarehouseIncidentsPage />
                                                </PermissionGuard>
                                            }
                                        />
                                        {/* M7 — REPACK & Picking fracionado (Supervisor): dividir,
                                            juntar/transferir e separar fracionado, sempre com o
                                            saldo antes × depois vindo da prévia do servidor.
                                            `wms:manage:repack` é também o que autoriza CRIAR pallet
                                            na hora (§6.2) — o chão faz o mesmo repack no coletor,
                                            mas contra um destino que já existe. */}
                                        <Route
                                            path="/warehouse/repack"
                                            element={
                                                <PermissionGuard permission="wms:manage:repack">
                                                    <WarehouseRepackPage />
                                                </PermissionGuard>
                                            }
                                        />
                                        {/* M5 — console do Supervisor: quadro de OSs + alocação
                                            com preview de split + comparador de rotas. A alocação
                                            é uma VISÃO desta rota (não um endereço próprio): é a
                                            mesma jornada, e o resultado dela cai no quadro ao lado.
                                            Permissão granular própria, como as outras do módulo. */}
                                        <Route
                                            path="/warehouse/service-orders"
                                            element={
                                                <PermissionGuard permission="wms:manage:service_orders">
                                                    <WarehouseServiceOrdersPage />
                                                </PermissionGuard>
                                            }
                                        />
                                        {/* M8 — EXPEDIÇÃO (Supervisor): o embarque é a sessão de
                                            carregamento de um ROMANEIO que já existe (o módulo de
                                            romaneio segue em /wms — §7: reutilize, não construa um
                                            segundo). Aqui vive o checklist do que deve embarcar × o
                                            que já foi bipado, a trava de 100% e o fechamento, que
                                            baixa estoque e dispara o espelho do Bling. O BIPE do
                                            carregamento é do chão, no coletor (`wms:operate`). */}
                                        <Route
                                            path="/warehouse/shipping"
                                            element={
                                                <PermissionGuard permission="wms:manage:shipping">
                                                    <WarehouseShippingPage />
                                                </PermissionGuard>
                                            }
                                        />
                                        {/* M9 — INVENTÁRIO (Supervisor): ocupação/heatmap, espaço
                                            ocioso e custo, SLA, FIFO/aging e a CONCILIAÇÃO com a
                                            trilha. Tudo leitura derivada — nenhum contador. A
                                            contagem é criada daqui, mas nasce pelo `POST
                                            /service-orders` do M5 e é executada no coletor. */}
                                        <Route
                                            path="/warehouse/inventory"
                                            element={
                                                <PermissionGuard permission="wms:manage:inventory">
                                                    <WarehouseInventoryPage />
                                                </PermissionGuard>
                                            }
                                        />

                                            <Route
                                                path="/users"
                                                element={
                                                    <PermissionGuard permission="users:read">
                                                        <Users />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/organizations"
                                                element={
                                                    <PermissionGuard permission="organizations:read">
                                                        <OrganizationsPage />
                                                    </PermissionGuard>
                                                }
                                            />
                                            <Route
                                                path="/users/:id"
                                                element={
                                                    <PermissionGuard permission="users:read">
                                                        <UserProfilePage />
                                                    </PermissionGuard>
                                                }
                                            />

                                            {/* Catch-all 404 — manter como ÚLTIMA rota do layout autenticado (sem PermissionGuard) */}
                                            <Route path="*" element={<NotFound />} />
                                        </Route>
                                    </Route>
                                </Routes>
                            </ToastProvider>
                        </CartProvider>
                    </DataCacheProvider>
                </AuthProvider>
            </ThemeProvider>
        </BrowserRouter>
    );
}

export default App;
